export default __webpack_public_path__ + "static/media/RoomConfig.e12d9168.svg";